module.exports = __webpack_public_path__ + "deQOb6xYFjuKhT0iy/icon_info.svg";